<script setup>
import { computed, toRaw } from 'vue'
import { storeToRefs } from 'pinia'
import { usePortalsStore } from '@/stores/portals'
import { PERSONALIZATION_RULE_STATUSES } from '@/constants'
import { capitalize } from 'lodash'
import moment from 'moment'

const emit = defineEmits(['click:copy'])

defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const portalsStore = usePortalsStore()

const { selectedPortal } = storeToRefs(portalsStore)

const rules = computed(() => selectedPortal.value.fields.policies.personalization.$rules.inputValue || [])

function conditionValuesDisplayText({ values, value_type }) {
  return values.map(value => valueDisplayText(value, value_type)).join(', ')
}

function valueDisplayText(value, valueType) {
  switch (valueType) {
    case 'currency':
      return `$${value}`
    case 'days':
      return `${value} days`
    default:
      return value
  }
}

function formatDate(date) {
  return date ? moment(date).format('MM/DD/YYYY HH:mm:ss') : null
}
</script>

<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>STATUS</th>
        <th>PUBLISH DATE</th>
        <th>NAME</th>
        <th>CONDITION</th>
        <th>OPERATOR</th>
        <th>VALUE</th>
        <th>ACTION(S)</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(rule, index) in rules" :key="index">
        <td>
          <select
            class="form-select"
            v-model="rule.status"
            :disabled="disabled"
          >
            <option v-for="(status, index) in PERSONALIZATION_RULE_STATUSES" :key="index" :value="status">
              {{ capitalize(status) }}
            </option>
          </select>
        </td>
        <td>
          {{ formatDate(rule.published_at) }}
        </td>
        <td>
          {{ rule.name }}
        </td>
        <td>
           {{ rule.conditions?.length ? rule.conditions[0].name : null }}
        </td>
        <td>
          {{ rule.conditions?.length ? rule.conditions[0].operator?.name : null }}
        </td>
        <td>
          {{ rule.conditions?.length ? conditionValuesDisplayText(rule.conditions[0]) : null }}
        </td>
        <td>
          <div v-for="(action, index) in rule.actions" :key="index">
            {{ `${action.name}: ${valueDisplayText(action.value, action.value_type)}` }}
          </div>
        </td>
        <td class="text-primary">
          <a href="#" @click="emit('click:copy', toRaw(rule))">
            <BootstrapIcon name="bs-icon-copy" />
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-if="rules.length === 0" class="fst-italic mt-4">
    No rules created yet.
  </div>
</template>
